import { render, staticRenderFns } from "./Reexamine.vue?vue&type=template&id=28d831d4&scoped=true&"
import script from "./Reexamine.vue?vue&type=script&lang=js&"
export * from "./Reexamine.vue?vue&type=script&lang=js&"
import style0 from "./Reexamine.vue?vue&type=style&index=0&id=28d831d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d831d4",
  null
  
)

export default component.exports